import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Waypoint from 'react-waypoint'
import { TextImageGridContainer, TextImageGridWrapper, IconContainer, ProductDetails } from './TextImageGrid.style'
import { Container } from '../../Container/Container.style'
import Image from '../../../shared/Image'

export default class TextImageGrid extends Component {
  constructor(props) {
    super(props)
    this.gridContainer = React.createRef()
    this.updateLeftPos = this.updateLeftPos.bind(this)
    this.state = {
      enableSticky: false,
      sticky: false,
      leftPos: 0,
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.updateLeftPos)
    }

    this.setState({
      leftPos: this.gridContainer.current.offsetLeft,
      // Only allow sticky icons if above a certain height, otherwise it won't scroll down enough to see
      enableSticky: this.gridContainer.current.offsetHeight > 600,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateLeftPos)
  }

  disableStickyIcons = () => {
    this.setState({
      sticky: false,
    })
  }

  disableStickyIconsScrollUp = ({ currentPosition, previousPosition }) => {
    const isAbove = currentPosition === Waypoint.above
    const wasInside = previousPosition === Waypoint.inside
    if (isAbove && wasInside) {
      this.setState({
        sticky: false,
      })
    }
  }

  detectSticky = ({ currentPosition, previousPosition }) => {
    const isAbove = currentPosition === Waypoint.above
    const wasInside = previousPosition === Waypoint.inside
    if (isAbove && wasInside) {
      this.setState({
        sticky: true,
      })
    } else {
      this.setState({
        sticky: false,
      })
    }
  }

  detectStickyScrollUp = ({ currentPosition, previousPosition }) => {
    const { sticky } = this.state

    if (!sticky) {
      const isInside = currentPosition === Waypoint.inside
      const isAbove = previousPosition === Waypoint.above
      if (isAbove && isInside) {
        this.setState({
          sticky: true,
        })
      }
    }
  }

  enableStickyIcons = () => {
    this.setState({
      sticky: true,
    })
  }

  updateLeftPos = () => {
    this.setState({
      leftPos: this.gridContainer.current.offsetLeft,
    })
  }

  render() {
    const { sticky, leftPos, enableSticky } = this.state
    const { productDetails, icon } = this.props

    return (
      <Fragment>
        { enableSticky && (
          <Waypoint
            onEnter={this.disableStickyIcons}
            onLeave={this.detectSticky}
            fireOnRapidScroll={false}
          />
        )}
        <TextImageGridContainer
          className="wow fadeIn"
          stickToTop={sticky}
          leftPos={leftPos}
        >
          <Container ref={this.gridContainer}>
            <TextImageGridWrapper>
              <IconContainer>
                { icon && (
                  <ul>
                    {icon.map(item => (
                      <li key={item.id}>
                        <Image src={item.imageFile.file.url} alt={item.altText} />
                      </li>
                    ))}
                  </ul>
                )}
              </IconContainer>

              <ProductDetails>
                <ul>
                  {productDetails &&
                  productDetails.map(item => {
                    return (
                      <li key={item.id}>
                        <Image
                          src={item.image.imageFile.file.url}
                          alt={item.image.altText}
                        />
                        <div className="description">
                          {item.title && <h4>{item.title}</h4>}
                          {item.description && (
                            <div
                              className="productDescription"
                              dangerouslySetInnerHTML={{
                                __html:
                                    item.description.childMarkdownRemark.html,
                              }}
                            />
                          )}
                        </div>
                      </li>
                    )
                  })}
                </ul>
              </ProductDetails>
            </TextImageGridWrapper>
          </Container>
        </TextImageGridContainer>
        { enableSticky && (
          <Waypoint
            onLeave={this.disableStickyIconsScrollUp}
            onEnter={this.detectStickyScrollUp}
            fireOnRapidScroll={false}
            topOffset="35%"
          />
        )}
      </Fragment>
    )
  }
}

export const TextImageGridFragment = graphql`
  fragment TextImageGridFragment on ContentfulTextImageGrid {
    id
    productDetails {
      id
      title
      image {
        imageFile {
          file {
            url
          }
        }
      }
      description {
        childMarkdownRemark {
          html
        }
      }
    }
    icon {
      id
      imageFile {
        file {
          url
        }
      }
    }
  }
`

TextImageGrid.propTypes = {
  icon: PropTypes.shape({
    altText: PropTypes.string.isRequired,
    imageFile: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    }),
  }).isRequired,
  productDetails: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.shape({
      childMarkdownRemark: PropTypes.shape({
        html: PropTypes.string,
      }),
    }),
  }).isRequired,
}
